// src/reducers/ingredients_reducers.js
import {
  FETCH_INGREDIENTS_PAGE_INFO_LOADING,
  FETCH_INGREDIENTS_PAGE_INFO_SUCCESS,
  FETCH_INGREDIENTS_PAGE_INFO_FAIL,
  FETCH_RECIPE_INGREDIENTS_ANALYTICS_LOADING,
  FETCH_RECIPE_INGREDIENTS_ANALYTICS_SUCCESS,
  FETCH_RECIPE_INGREDIENTS_ANALYTICS_FAIL
} from '../actions/types';

const INITIAL_STATE = {
  // array of objects: { viewCount, count, name, header, image, details, recipeCount, recipeDetails }
  ingredientsPageInfo: [],
  loadingIngredientsPageInfo: false,
  ingredientsPageInfoError: null,

  recipeIngredients: null,
  loadingRecipeIngredients: false,
  recipeIngredientsError: null
};

const ingredientsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_INGREDIENTS_PAGE_INFO_LOADING:
      return {
        ...state,
        loadingIngredientsPageInfo: true,
        ingredientsPageInfoError: null
      };

    case FETCH_INGREDIENTS_PAGE_INFO_SUCCESS:
      return {
        ...state,
        loadingIngredientsPageInfo: false,
        ingredientsPageInfo: action.payload || [],
        ingredientsPageInfoError: null
      };

    case FETCH_INGREDIENTS_PAGE_INFO_FAIL:
      return {
        ...state,
        loadingIngredientsPageInfo: false,
        ingredientsPageInfo: [],
        ingredientsPageInfoError: action.payload
      };
      
    // recipe/:id/ingredients
    case FETCH_RECIPE_INGREDIENTS_ANALYTICS_LOADING:
      return {
        ...state,
        loadingRecipeIngredients: true,
        recipeIngredientsError: null
      };

    case FETCH_RECIPE_INGREDIENTS_ANALYTICS_SUCCESS:
      return {
        ...state,
        loadingRecipeIngredients: false,
        // expect { recipe: {...}, ingredients: [...] }
        recipeIngredients: action.payload || { recipe: null, ingredients: [] },
        recipeIngredientsError: null
      };

    case FETCH_RECIPE_INGREDIENTS_ANALYTICS_FAIL:
      return {
        ...state,
        loadingRecipeIngredients: false,
        recipeIngredients: { recipe: null, ingredients: [] },
        recipeIngredientsError: action.payload
      };

    default:
      return state;
  }
};

export default ingredientsReducer;
